import ServiceLayout from "@/components/ServiceLayout";
import { QuoteModal } from "@/components/QuoteModal";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export default function Heidenheim() {
  return (
    <ServiceLayout
      title="Umzugsunternehmen in Heidenheim an der Brenz"
      description="Ihr lokaler Partner für stressfreie Umzüge, Möbelmontage und Handwerksleistungen direkt in Heidenheim an der Brenz und Umgebung."
      image="https://vibe.filesafe.space/1781514922662573702/assets/7fc4e3d1-e123-4471-9a61-5c6d061d7619.png"
      heroBg="https://vibe.filesafe.space/1781514922662573702/assets/4f1c74d5-3158-4bae-a209-c2ea1ab42a32.png"
      content={
        <>
          <h2 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight">
            Ihr Umzug in Heidenheim an der Brenz
          </h2>
          <p className="text-lg text-neutral-600">
            Als erfahrenes Umzugsunternehmen kennen wir Heidenheim an der Brenz und die umliegenden Gebiete sehr gut. Egal ob Sie innerhalb von Heidenheim umziehen, neu zuziehen oder die Stadt verlassen – wir sorgen für einen reibungslosen Ablauf.
          </p>
          <p className="text-lg text-neutral-600">
            Wir planen präzise und setzen Ihren Umzug termingerecht um, damit Sie sich entspannt auf Ihr neues Zuhause freuen können.
          </p>
          <ul className="space-y-3 mt-6">
            {[
              "Ortskundige Fahrer & Planer",
              "Einrichtung von Halteverbotszonen",
              "Kurze Anfahrtswege",
              "Kostenlose Besichtigung vor Ort"
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3 text-neutral-800 font-medium">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                {item}
              </li>
            ))}
          </ul>
        </>
      }
      extendedContent={
        <div className="bg-white">
          <section className="py-16 bg-neutral-50">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Ihr verlässliches Umzugsunternehmen in Heidenheim an der Brenz</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ein Umzug erfordert viel Planung, Zeit und körperliche Anstrengung. Als Ihr professionelles Umzugsunternehmen für Heidenheim an der Brenz und Umgebung nehmen wir Ihnen diese Last ab. Wir sorgen dafür, dass Ihr Wohnungswechsel oder Firmenumzug reibungslos und stressfrei über die Bühne geht.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Egal ob Sie innerhalb von Heidenheim umziehen, neu in die Stadt an der Brenz ziehen oder die Region verlassen – wir kennen die örtlichen Gegebenheiten. Wir planen die optimalen Transportwege, kümmern uns um Halteverbotszonen und garantieren einen sicheren Transport Ihres Hab und Guts.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Kostenloses Angebot anfordern
                      </Button>
                    </QuoteModal>
                    <Button size="lg" variant="secondary" asChild className="w-full sm:w-auto">
                      <a href="tel:+4915888640762">
                        <Phone className="w-5 h-5 mr-2" />
                        +49 15888 640762
                      </a>
                    </Button>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8 pt-8">
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Privatumzüge in Heidenheim</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Wir bieten Ihnen maßgeschneiderte Lösungen für Ihren Privatumzug. Vom reinen Transport bis zum Full-Service-Umzug inklusive Einpacken und Möbelmontage – wir richten uns ganz nach Ihren Bedürfnissen und Ihrem Budget.
                    </p>
                  </div>
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Gewerbliche Umzüge</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Für Unternehmen in Heidenheim bieten wir professionelle Firmenumzüge an. Wir arbeiten schnell und effizient, um die Ausfallzeiten Ihres Betriebs zu minimieren, und transportieren IT-Equipment und Büromöbel sicher.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Umfassende Handwerksleistungen für Ihren Neustart</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Unser Service geht weit über den reinen Möbeltransport hinaus. Unsere erfahrenen Handwerker übernehmen die fachgerechte Demontage und Montage Ihrer Möbel. Auch komplizierte Schrankwände oder Küchen bauen wir sicher ab und in Ihrem neuen Zuhause in Heidenheim wieder auf.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Zudem bieten wir professionelle Elektro- und Lichtinstallationen an. Wir schließen Ihre Lampen, Herde und Waschmaschinen an. Auch für Bodenbelagsarbeiten und kleinere Renovierungen stehen wir Ihnen zur Verfügung, damit Sie sich sofort wohlfühlen können.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Jetzt beraten lassen
                      </Button>
                    </QuoteModal>
                  </div>
                </div>

                <div className="bg-primary/5 p-8 border-l-4 border-primary mt-8">
                  <h3 className="font-heading text-2xl font-bold mb-3">Festpreisgarantie und Sicherheit</h3>
                  <p className="text-neutral-700 leading-relaxed">
                    Wir legen großen Wert auf Transparenz. Nach einer kostenlosen Besichtigung in Heidenheim erhalten Sie ein verbindliches Festpreisangebot. Keine versteckten Kosten. Zudem ist Ihr Umzugsgut während des gesamten Transports und der Montagearbeiten vollumfänglich versichert.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-neutral-950 text-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto text-center">
                <h2 className="font-heading text-3xl font-bold mb-6">Gründe für Easy Umzug in Heidenheim</h2>
                <div className="grid sm:grid-cols-3 gap-8 mt-12 text-left">
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Regionale Erfahrung</h3>
                    <p className="text-neutral-400">Wir kennen Heidenheim an der Brenz und sorgen für eine optimale Routenplanung.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Sorgfalt & Sicherheit</h3>
                    <p className="text-neutral-400">Ihr Eigentum wird von uns professionell verpackt und sicher transportiert.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Faire Festpreise</h3>
                    <p className="text-neutral-400">Transparente Preisgestaltung ohne versteckte Kosten nach einer kostenlosen Besichtigung.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      }
    />
  );
}
